export default () =>
  new Promise((resolve, reject) => {
    window.axios
      .get(`${process.env.VUE_APP_API_ADMIN_LOCATION}users/roles`)
      .then(({ data }) => {
        resolve(data.users);
      })
      .catch((error) => {
        reject(error);
      });
  });
